// Force a full page reload for devices that try
// to draw from a back/forward cache.
const forceRealPageReload = (event) => {
    if (event.originalEvent.persisted) {
        window.location.reload();
    }
};

export default forceRealPageReload;
